import { Vector3 } from "three";
import { MAX_GEOMETRY_DIMENSION } from "../config";
import { TraceIntersectionFromPosition } from "../common";
export function lookAtFront(preview, duration) {
  return preview.adjustRotation({
    azimuth: 0,
    polar: Math.PI / 2,
    duration
  });
}
export function lookAtRight(preview, duration) {
  return preview.adjustRotation({
    azimuth: Math.PI / 2,
    polar: Math.PI / 2,
    duration
  });
}
export function lookAtLeft(preview, duration) {
  return preview.adjustRotation({
    azimuth: -Math.PI / 2,
    polar: Math.PI / 2,
    duration
  });
}
export function lookAtBack(preview, duration) {
  return preview.adjustRotation({
    azimuth: Math.PI,
    polar: Math.PI / 2,
    duration
  });
}
export function cameraIntersection(preview) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const {
    position
  } = preview.camera.camera;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const direction = preview.camera.controls.getDirection();
  const intersections =
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  TraceIntersectionFromPosition(position, direction, preview.scene);
  if (preview.product && intersections) {
    const surfaceMapping = preview.product.getSurfaceMapping();
    for (const intersection of intersections) {
      if (surfaceMapping[intersection.object.uuid]) {
        return {
          id: intersection.object.uuid,
          surface: surfaceMapping[intersection.object.uuid]
        };
      }
    }
  }
  return undefined;
}
/**
 * Determine the distance in world units between two camera views.
 * Ex: If the start and the end have the same focalPoint and zoom, the angle between them is 180 degrees, the distance will be twice the zoom * MAX_GEOMETRY_DIMENSION
 * Ex: If the start and the end have the same rotation and zoom, this will give the distance between the focal points.
 * In general, give the straight line distance between the locations of the cameras in 3-space corresponding to the CameraViews.
 */
export function cameraDistance(start, end) {
  // Get the focal points as vectors. Start our camera locations at these points.
  const sPoint = new Vector3(start.focalPoint.x, start.focalPoint.y, start.focalPoint.z);
  const ePoint = new Vector3(end.focalPoint.x, end.focalPoint.y, end.focalPoint.z);
  // Get the vectors from the focal point to the camera using spherical coordinates. Adjust zoom to world units.
  const sOffset = new Vector3().setFromSphericalCoords(start.zoom * MAX_GEOMETRY_DIMENSION, start.rotation.polar, start.rotation.azimuth);
  const eOffset = new Vector3().setFromSphericalCoords(end.zoom * MAX_GEOMETRY_DIMENSION, end.rotation.polar, end.rotation.azimuth);
  // The actually locations of the camera are the focalPoint plus the vector to the camera. point.add changes the point by the parameter vector.
  sPoint.add(sOffset);
  ePoint.add(eOffset);
  // Find the distance
  return sPoint.distanceTo(ePoint);
}